import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UpdateFeedbackMutationVariables = Types.Exact<{
  input: Types.UpdateFeedbackInput;
}>;


export type UpdateFeedbackMutation = { updateFeedback: { feedback?: { id: string } | null } };


export const UpdateFeedbackDocument = /*#__PURE__*/ gql`
    mutation updateFeedback($input: UpdateFeedbackInput!) {
  updateFeedback(input: $input) {
    feedback {
      id
    }
  }
}
    `;

export function useUpdateFeedbackMutation() {
  return Urql.useMutation<UpdateFeedbackMutation, UpdateFeedbackMutationVariables>(UpdateFeedbackDocument);
};